const copyToClipboard = (value: string, element: string) => {
  let inp = document.createElement('textarea')
  let modal = document.getElementById(element)
  if (modal !== null) modal.appendChild(inp)
  inp.innerText = value
  inp.select()
  document.execCommand('copy', false)
  inp.remove()
}

export default copyToClipboard
